<template>
    <label class="label-item" :class="[position]">
        <div class="label-ti" :style="{width: labelWidth}">{{label}} <span v-if="must">*</span></div>
        <slot></slot>
        <div class="warn-tip" v-if="tip" :style="{paddingLeft: position == 'left' ? labelWidth : ''}">{{tip}}</div>
    </label>
</template>

<script>
    import {checkValue} from "./validate";
    export default {
        name: "clLabel",
        props: {
            prop: String,
            label: String,
            labelWidth: String,
            position: {
                type: String,
                default: 'top'
            }
        },
        inject: ['clForm'],
        data() {
            return {
                tip: null
            }
        },
        computed: {
            rules() {
                let res = [];
                if(this.prop && this.clForm && this.clForm.rules) {
                    res = this.clForm.rules[this.prop];
                }
                return res;
            },
            must() {
                let rules = this.rules;
                return rules && rules.length > 0 ? rules.findIndex(r => r.require) >= 0 : false;
            }
        },
        created() {
            if(this.prop && this.clForm) {
                this.clForm.$emit.call(this.clForm, "cl.form.addField", this);
            }
        },
        beforeDestroy() {
            this.clForm && this.clForm.$emit.call(this.clForm, "cl.form.removeField", this);
        },
        methods: {
            getValue() {
                let res = null;
                if(this.prop && this.clForm && this.clForm.modal) {
                    res = this.clForm.modal[this.prop];
                }
                return res;
            },
            checkProp() {
                let rules = this.rules||[];
                if(rules.length > 0) {
                    let value = this.getValue();
                    let tip = checkValue(rules, value);
                    if(tip) {
                        this.tip = tip;
                    } else {
                        this.tip = null;
                    }
                    return !tip;
                } else {
                    return true;
                }
            }
        }
    }
</script>

<style lang="less">
    .label-item {
        display: flex;
        padding-bottom: 32px;
        position: relative;
        &.top {
            flex-direction: column;
        }
        &.left {
            .label-ti {
                padding: 0;
                width: 160px;
                height: 60px;
                line-height: 60px;
            }
            .warn-tip {
                padding-left: 160px;
            }
        }
    }
    .label-ti {
        flex-shrink: 0;
        padding: 8px 0 20px;
        color: var(--tip-font-color);
        span {
            color: var(--warn-color);
        }
    }
    .warn-tip {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        font-size: 24px;
        color: var(--warn-color);
    }
</style>
